module.exports = __webpack_public_path__ + "img/444.8574dc81.jpg";